export default __webpack_public_path__ + "028ec116fc2eb6a20c8deaa39d87e667.png";